import { useEffect, useState } from 'react'
import { SmartBeadMark } from './SmartBeadMark'

interface SpinnerProps {
  /** Pixel size of the mark. */
  size?: number
  label?: string
  /** Wait this long before showing anything, so quick (cached) loads don't flash
   *  a loader in and out. Set 0 to show immediately. */
  delayMs?: number
}

/**
 * The app's loading indicator — the animated KandiTag smart-bead mark. It stays
 * INVISIBLE for the first `delayMs` so fast loads (the common case with the
 * Firestore cache) never flash a spinner; only a genuinely slow load reveals it.
 * The surrounding screen is the dark app background, so the brief pre-delay gap
 * reads as a normal page transition, not a loading state.
 */
export const Spinner = ({ size = 32, label = 'Loading', delayMs = 500 }: SpinnerProps) => {
  const [show, setShow] = useState(delayMs <= 0)
  useEffect(() => {
    if (delayMs <= 0) return
    const t = setTimeout(() => setShow(true), delayMs)
    return () => clearTimeout(t)
  }, [delayMs])

  if (!show) return null
  return (
    <span role="status" aria-label={label} className="inline-flex">
      <SmartBeadMark size={size} animated />
    </span>
  )
}
